import src from "IMAGE";
export default { src, width: 5308, height: 728, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AIDNmKm75NRSteHXVrnj2FG+5dtMtOHWWMHm20na8OsrbGEWFKr+I2sAAAAASUVORK5CYII="};
